/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, Paper } from '@material-ui/core'
import React from 'react'
import NumberFormat from 'react-number-format'
import { ReactComponent as ProcedureIcon } from '../Assets/procedure.svg'
import { ProcedureItem } from '../Config/Procedures/types'
import { useBudgetStyles } from './styles'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

interface BudgetProps {
  procedureItem: ProcedureItem & { side?: 'left' | 'right' }
  onClick?: () => void
  onChangeSide?: (newSide: 'left' | 'right') => void
  icon?: JSX.Element
}

const BudgetCard: React.FC<BudgetProps> = props => {
  const classes = useBudgetStyles()
  const { procedureItem, onClick, onChangeSide } = props

  return (
    <Paper elevation={0} className={classes.root} onClick={onClick}>
      <Grid container justify="space-around" alignItems="center">
        <Grid xs={4} className={classes.name} style={{ textAlign: 'left' }}>
          <ProcedureIcon className={classes.icon} style={{ marginRight: 10 }} />
          {procedureItem.name}
        </Grid>
        <Grid xs={4} className={classes.value} style={{ textAlign: 'center' }}>
          <NumberFormat
            prefix="R$ "
            isNumericString
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            displayType="text"
            value={procedureItem.price.float}
          />
        </Grid>
        {procedureItem.side && (
          <Grid xs={2}>
            <Select
              value={procedureItem.side}
              onChange={(e: any) =>
                onChangeSide?.(e.target.value as 'left' | 'right')
              }
            >
              <MenuItem value={'right'}>Direito</MenuItem>
              <MenuItem value={'left'}>Esquerdo</MenuItem>
            </Select>
          </Grid>
        )}
        <Grid xs={2} style={{ textAlign: 'right' }}>
          {props.icon}
        </Grid>
      </Grid>
    </Paper>
  )
}

export default BudgetCard
